export const getInitialValues = ({ event_limit: eventLimit }) => ({
  eventLimitsInitialized: true,
  dailyLimit: eventLimit?.daily_limit || undefined,
  weeklyLimit: eventLimit?.weekly_limit || undefined,
  monthlyLimit: eventLimit?.monthly_limit || undefined,
})
